import React from 'react'
import _ from 'lodash'
import { formatData } from './events'
import Typography from '@mui/material/Typography'

const ActionStatusClass = ({ row, sx }) => {
  const status = _.get(row, 'statusClass', '-')
  const canceledBy = _.get(row, 'canceledBy', '-')
  const { label, color } = formatData(status, canceledBy)
  return (
    <Typography variant="body2" sx={{ ...sx, color }}>
      {label}
    </Typography>
  )
}

export default ActionStatusClass
